import React from "react";

function SvgIcMapPoi020(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M8.474 5a.5.5 0 110 1h-.28l1.935 5.96v.026l7.838-.99c.006 0 .01.006.017.006L18 11c.551 0 1 .448 1 1l-1 5.333a.98.98 0 01-.066.325l1.804 7.997a.997.997 0 01-.515 1.316.998.998 0 01-1.317-.513l-1.833-8.125h-.058l-.023 7.66a1 1 0 11-2 0l.023-8.587c-.002-.025-.015-.047-.015-.073V14h-3.976c-.552 0-1-.449-1-1a.98.98 0 01.233-.618.495.495 0 01-.104-.204l-2.077-6.39a.49.49 0 01-.102-.288c0-.23.158-.415.37-.474.017-.006.03-.018.05-.022.023-.006.045 0 .07-.002L7.473 5zM24 24a1 1 0 110 2 1 1 0 010-2zM16.999 6a2 2 0 11.003 4 2 2 0 01-.003-4z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi020;
